import React, { Component } from 'react';
import { Stack } from 'react-bootstrap';
import './ButtonNumList.css';

class ButtonNumList extends Component {
    constructor(props) {
        super(props);
        this.buttonContainer = React.createRef();
        this.state = {
          selectedValue: this.props?.min ?? null,
          buttonWidth:0,
        };
    }

      componentDidMount () {
        this.min = this.props?.min ?? 0;
        this.max = this.props?.max ?? 10;
        this.N = this.max - this.min + 1;
        const resizeObserver = new ResizeObserver((event) => {
            if  (this.buttonContainer.current === null) 
                return;
            let width = (this.buttonContainer.current.offsetWidth / this.N) - 3;
            if (width !== this.state.width) {
                this.setState({ width: width});
            }            
        });
        resizeObserver.observe(document.getElementById("buttonGroup"));      
      }

      clicked(value){
        if(this.state.selectedValue !== null){
          document.getElementById("btn" + this.state.selectedValue).classList.remove('activated');
        }
        document.getElementById("btn" + value).classList.add("activated");
        this.setState({selectedValue: value});
        this.props?.onChanged(value);
      }

      render () {
        const buttons = [];
        for (let i = this.min; i <= this.max; i++) {
          let id = `btn${i}`;
            buttons.push(
              <button key={i} href='#' style={{"width":this.state.width, "height":"63px"}} id={id} className="click" onClick={() => this.clicked(i)}>{i}</button>
            );
        }        
        return (
          <div id='buttonGroup' className='buttonGroup trueGreenBorderColor'  ref = {this.buttonContainer}>
              <div>
                {buttons}
              </div>
          </div>
        )
      } 
}

export default ButtonNumList;